import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

const apiUrl = import.meta.env.VITE_API_URL;

export function getSocket(): Socket {
  if (!socket) {
    socket = io(apiUrl, {
      autoConnect: false, // don’t auto-connect, control it manually
      reconnection: true, // enable reconnection
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      secure: true,
      transports: ['websocket'],
    });
  }
  return socket;
}

export function connectSocket() {
  const s = getSocket();
  if (!s.connected) {
    s.connect();
  }
}

export function disconnectSocket() {
  const s = getSocket();
  if (s.connected) {
    s.disconnect();
  }
}
